import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=4d4c5a34&scoped=true"
import script from "./Tags.vue?vue&type=script&setup=true&lang=js"
export * from "./Tags.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=4d4c5a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c5a34",
  null
  
)

export default component.exports